// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/pagination";
// import { FreeMode, Navigation, Autoplay } from "swiper/modules";
// import { Card } from "react-bootstrap";
// import { Link, useNavigate } from "react-router-dom";



// const VideoGallery = ({ latestBlog, franchiseData }) => {
//   const navigate = useNavigate();
//   const handleBlogClick = (slide) => {
//     navigate(`/${slide?.url.replace(/\s+/g, "-").replace(/~/g, "-").toLowerCase()}`, {
//       state: {
//         id: slide?.id,
//         name: slide?.url || slide?.description,
//       },
//     });
//   };

//   return (
//     <div className="video_gallery them-font">
//       <div className="container">
//         <div className="title-bx">
//           <div className="text-center fs-2 pt-3 saree-heading">
//             {franchiseData?.video_title}
//           </div>
//           <div className="des them-font">
//             {franchiseData?.video_description}
//           </div>
//         </div>
//         <div className="row">

//           <Swiper
//             slidesPerView={3}
//             spaceBetween={30}
//             freeMode={true}
//             navigation={true}
//             autoplay={{
//               delay: 3000,
//               disableOnInteraction: false,
//             }}
//             modules={[FreeMode, Navigation, Autoplay]}
//             className="mySwiper"
//             breakpoints={{
//               220: {
//                 slidesPerView: 1,
//                 spaceBetween: 10,
//               },
//               480: {
//                 slidesPerView: 1,
//                 spaceBetween: 10,
//               },
//               640: {
//                 slidesPerView: 2,
//                 spaceBetween: 10,
//               },
//               1024: {
//                 slidesPerView: 3,
//                 spaceBetween: 20,
//               },
//             }}
//           >
//             {latestBlog.map((slide, i) => (
//               <SwiperSlide key={i}>
//                 <div className="p-2">
//                   <a
//                     href={slide.video}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Card
//                       className="border-dark mt-3 theme-shadow"
//                       style={{
//                         background: "white",
//                         overflow: "hidden",
//                         aspectRatio: "11/9",
//                         cursor: "pointer",
//                         borderRadius: "25px",
//                       }}
//                     >
//                       <Card.Img
//                         variant="top"
//                         src={slide.image}
//                         className="img-fluid"
//                         style={{ aspectRatio: "16/9", objectFit: "cover" }}
//                         loading="lazy"
//                         alt={slide.title}
//                       />
//                       <p className="d-none d-sm-block text-center text-wrap fw-medium mt-3">
//                         {slide.title}
//                       </p>
//                        <p className="d-block d-sm-none text-center text-wrap fw-medium mt-1" style={{ fontSize: "0.8rem" }}>
//                       {slide.title}{" "}
//                     </p> 
//                     </Card>
//                   </a>
//                 </div>
//               </SwiperSlide>
//             ))}

//           </Swiper>

//           <div className="col-12 text-center">
//             <div className="text-center pb-3">
//               <a
//                 href="https://www.youtube.com/channel/UCZbRY7cq891wnFiZkONgGRA"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <button
//                   className="moreBtn active btn-red-to-black-color-move rounded-4 mt-3 px-4 py-2"
//                   title="Enquire Now"
//                   style={{
//                     backgroundColor: "#da212b",
//                     color: "white",
//                   }}
//                 >
//                   <span> View More videos </span>
//                 </button>
//               </a>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VideoGallery;
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Navigation, Autoplay } from "swiper/modules";
import { Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const VideoGallery = ({ latestBlog, franchiseData }) => {
  const navigate = useNavigate();
  
  // Function to extract YouTube thumbnail from URL
  const getYouTubeThumbnail = (url) => {
    let videoId = '';
    
    // Regular YouTube URL
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1];
      const ampersandPosition = videoId.indexOf('&');
      if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
      }
    } 
    // Short YouTube URL
    else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1];
      const questionMarkPosition = videoId.indexOf('?');
      if (questionMarkPosition !== -1) {
        videoId = videoId.substring(0, questionMarkPosition);
      }
    }
    
    if (videoId) {
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }
    
    // Return a default image if URL is not recognized
    return 'https://via.placeholder.com/800x450';
  };

  const handleBlogClick = (slide) => {
    navigate(`/${slide?.url.replace(/\s+/g, "-").replace(/~/g, "-").toLowerCase()}`, {
      state: {
        id: slide?.id,
        name: slide?.url || slide?.description,
      },
    });
  };

  return (
    <div className="video_gallery them-font">
      <div className="container">
        <div className="title-bx">
          <div className="text-center fs-2 pt-3 saree-heading">
            {franchiseData?.video_title}
          </div>
          <div className="des them-font">
            {franchiseData?.video_description}
          </div>
        </div>
        <div className="row">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            navigation={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[FreeMode, Navigation, Autoplay]}
            className="mySwiper"
            breakpoints={{
              220: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
          >
            {latestBlog.map((slide, i) => (
              <SwiperSlide key={i}>
                <div className="p-2">
                  <a
                    href={slide.video}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Card
                      className="border-dark mt-3 theme-shadow"
                      style={{
                        background: "white",
                        overflow: "hidden",
                        aspectRatio: "11/9",
                        cursor: "pointer",
                        borderRadius: "25px",
                      }}
                    >
                      <Card.Img
                        variant="top"
                        src={getYouTubeThumbnail(slide.video)}
                        className="img-fluid"
                        style={{ aspectRatio: "16/9", objectFit: "cover" }}
                        loading="lazy"
                        alt={slide.title}
                        // onError={(e) => {
                        //   // Fallback to a lower quality thumbnail if maxresdefault doesn't exist
                        //   if (slide.video.includes('youtube.com')) {
                        //     const videoId = slide.video.split('v=')[1];
                        //     e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                        //   }
                        // }}
                      />
                      <p className="d-none d-sm-block text-center text-wrap fw-medium mt-3">
                        {slide.title}
                      </p>
                      <p className="d-block d-sm-none text-center text-wrap fw-medium mt-1" style={{ fontSize: "0.8rem" }}>
                        {slide.title}{" "}
                      </p> 
                    </Card>
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="col-12 text-center">
            <div className="text-center pb-3">
              <a
                href="https://www.youtube.com/channel/UCZbRY7cq891wnFiZkONgGRA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  className="moreBtn active btn-red-to-black-color-move rounded-4 mt-3 px-4 py-2"
                  title="Enquire Now"
                  style={{
                    backgroundColor: "#da212b",
                    color: "white",
                  }}
                >
                  <span> View More videos </span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default VideoGallery;